import classNames from "classnames";

import type { SafeHtmlAttributes } from "../../types/SafeHtmlAttributes";

import styles from "./Loader.module.scss";

type LoaderProps = SafeHtmlAttributes<SVGSVGElement> & {
  size?: "sm" | "md" | "lg";
  isInverse?: boolean;
};

export const Loader = ({ size = "sm", isInverse = false, role = "progressbar", ...rest }: LoaderProps) => {
  return (
    <svg
      {...rest}
      role={role}
      className={classNames(styles.svgContainer, styles[size], { [styles.isInverse]: isInverse })}
      viewBox="25 25 50 50"
      focusable="false"
    >
      <circle aria-hidden="true" className={styles.circleTrack} r="20" cy="50" cx="50"></circle>
      <circle aria-hidden="true" className={styles.circleIndicator} r="20" cy="50" cx="50"></circle>
    </svg>
  );
};
